import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "./Password.css";
import API_URL from "../Config"; // Adjust the path based on your file structure

const Password = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  console.log("Password component has rendered!");

  const queryParams = new URLSearchParams(location.search);
  const token_id = queryParams.get("token_id");

  useEffect(() => {
    if (!token_id) {
      setMessage("Invalid or missing token.");
      setTimeout(() => navigate("/login"), 2000); // Navigate after 2s
    }
  }, [token_id, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setPasswordMatch(false);
      return;
    }

    setPasswordMatch(true);
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${API_URL}/api/complete_registration?token_id=${token_id}`, // Sending token_id as a query parameter
        { password: newPassword } // Sending only password in the body
      );

      if (response.status === 200) {
        setMessage("Password reset successfully!");
        setTimeout(() => navigate("/login"), 2000);
      }
    } catch (error) {
      setMessage(
        "Error resetting password: " +
          (error.response?.data?.message || "Unknown error")
      );
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="ca-password-container">
      <div className="ca-password-box">
        <h1>Reset Password</h1>
        {message && (
          <div
            className={`ca-password-message ${
              message.includes("Error") ? "error" : ""
            }`}
          >
            {message}
          </div>
        )}
        <form onSubmit={handleSubmit} className="ca-password-form">
          <div className="ca-password-group">
            <label htmlFor="newPassword">New Password</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className={`ca-password-input ${
                newPassword.length > 0 && newPassword.length < 8
                  ? "input-error"
                  : ""
              }`}
            />
            {newPassword.length > 0 && newPassword.length < 8 && (
              <div className="ca-password-error-message">
                Password must be at least 8 characters long.
              </div>
            )}
          </div>
          <div className="ca-password-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className={`ca-password-input ${
                !passwordMatch ? "input-error" : ""
              }`}
            />
            {!passwordMatch && (
              <div className="ca-password-error-message">
                Passwords do not match.
              </div>
            )}
          </div>
          <button
            type="submit"
            disabled={isLoading || newPassword.length < 8 || !passwordMatch}
            className="ca-password-btn"
          >
            {isLoading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Password;